import { gettext } from '@eventbrite/i18n';
import appearance_link from '../../../static/images/formats/format_links/appearance.jpg';
import attraction_link from '../../../static/images/formats/format_links/attraction.jpg';
import classes_link from '../../../static/images/formats/format_links/classes.jpg';
import conference_link from '../../../static/images/formats/format_links/conference.jpg';
import convention_link from '../../../static/images/formats/format_links/convention.jpg';
import expo_link from '../../../static/images/formats/format_links/expo.jpg';
import festival_link from '../../../static/images/formats/format_links/festival.jpg';
import gala_link from '../../../static/images/formats/format_links/gala.jpg';
import game_link from '../../../static/images/formats/format_links/game.jpg';
import networking_link from '../../../static/images/formats/format_links/networking.jpg';
import party_link from '../../../static/images/formats/format_links/party.jpg';
import performance_link from '../../../static/images/formats/format_links/performance.jpg';
import race_link from '../../../static/images/formats/format_links/race.jpg';
import rally_link from '../../../static/images/formats/format_links/rally.jpg';
import retreat_link from '../../../static/images/formats/format_links/retreat.jpg';
import screening_link from '../../../static/images/formats/format_links/screening.jpg';
import seminar_link from '../../../static/images/formats/format_links/seminar.jpg';
import tour_link from '../../../static/images/formats/format_links/tour.jpg';
import tournament_link from '../../../static/images/formats/format_links/tournament.jpg';

//Eventbrite Format ID Mappings
const CONFERENCE = 1;
const SEMINAR = 2;
const EXPO = 3;
const CONVENTION = 4;
const FESTIVAL = 5;
const PERFORMANCE = 6;
const SCREENING = 7;
const GALA = 8;
const CLASS = 9;
const NETWORKING = 10;
const PARTY = 11;
const RALLY = 12;
const TOURNAMENT = 13;
const GAME = 14;
const RACE = 15;
const TOUR = 16;
const ATTRACTION = 17;
const RETREAT = 18;
const APPEARANCE = 19;

export const FORMAT_TAG_TYPE = 'Format';
export const EVENTBRITE_FORMAT = 'EventbriteFormat';

export const CONFERENCE_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${CONFERENCE}`;
export const SEMINAR_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${SEMINAR}`;
export const EXPO_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${EXPO}`;
export const CONVENTION_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${CONVENTION}`;
export const FESTIVAL_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${FESTIVAL}`;
export const PERFORMANCE_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${PERFORMANCE}`;
export const SCREENING_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${SCREENING}`;
export const GALA_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${GALA}`;
export const CLASS_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${CLASS}`;
export const NETWORKING_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${NETWORKING}`;
export const PARTY_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${PARTY}`;
export const RALLY_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${RALLY}`;
export const TOURNAMENT_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${TOURNAMENT}`;
export const GAME_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${GAME}`;
export const RACE_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${RACE}`;
export const TOUR_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${TOUR}`;
export const ATTRACTION_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${ATTRACTION}`;
export const RETREAT_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${RETREAT}`;
export const APPEARANCE_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${APPEARANCE}`;

export const EVENTBRITE_FORMAT_MAPPING = {
    [CONFERENCE_EVENTBRITE_FORMAT]: gettext('Conferences'),
    [SEMINAR_EVENTBRITE_FORMAT]: gettext('Seminars'),
    [EXPO_EVENTBRITE_FORMAT]: gettext('Expos'),
    [CONVENTION_EVENTBRITE_FORMAT]: gettext('Conventions'),
    [FESTIVAL_EVENTBRITE_FORMAT]: gettext('Festivals'),
    [PERFORMANCE_EVENTBRITE_FORMAT]: gettext('Performances'),
    [SCREENING_EVENTBRITE_FORMAT]: gettext('Screenings'),
    [GALA_EVENTBRITE_FORMAT]: gettext('Galas'),
    [CLASS_EVENTBRITE_FORMAT]: gettext('Classes'),
    [NETWORKING_EVENTBRITE_FORMAT]: gettext('Networking'),
    [PARTY_EVENTBRITE_FORMAT]: gettext('Parties'),
    [RALLY_EVENTBRITE_FORMAT]: gettext('Rallies'),
    [TOURNAMENT_EVENTBRITE_FORMAT]: gettext('Tournaments'),
    [GAME_EVENTBRITE_FORMAT]: gettext('Games'),
    [RACE_EVENTBRITE_FORMAT]: gettext('Races'),
    [TOUR_EVENTBRITE_FORMAT]: gettext('Tours'),
    [ATTRACTION_EVENTBRITE_FORMAT]: gettext('Attractions'),
    [RETREAT_EVENTBRITE_FORMAT]: gettext('Retreats'),
    [APPEARANCE_EVENTBRITE_FORMAT]: gettext('Appearances'),
};

export const EVENTBRITE_FORMAT_IMAGE_MAPPING = {
    [CONFERENCE_EVENTBRITE_FORMAT]: {
        link: conference_link,
        full: '',
    },
    [SEMINAR_EVENTBRITE_FORMAT]: {
        link: seminar_link,
        full: '',
    },
    [EXPO_EVENTBRITE_FORMAT]: {
        link: expo_link,
        full: '',
    },
    [CONVENTION_EVENTBRITE_FORMAT]: {
        link: convention_link,
        full: '',
    },
    [FESTIVAL_EVENTBRITE_FORMAT]: {
        link: festival_link,
        full: '',
    },
    [PERFORMANCE_EVENTBRITE_FORMAT]: {
        link: performance_link,
        full: '',
    },
    [SCREENING_EVENTBRITE_FORMAT]: {
        link: screening_link,
        full: '',
    },
    [GALA_EVENTBRITE_FORMAT]: {
        link: gala_link,
        full: '',
    },
    [CLASS_EVENTBRITE_FORMAT]: {
        link: classes_link,
        full: '',
    },
    [NETWORKING_EVENTBRITE_FORMAT]: {
        link: networking_link,
        full: '',
    },
    [PARTY_EVENTBRITE_FORMAT]: {
        link: party_link,
        full: '',
    },
    [RALLY_EVENTBRITE_FORMAT]: {
        link: rally_link,
        full: '',
    },
    [TOURNAMENT_EVENTBRITE_FORMAT]: {
        link: tournament_link,
        full: '',
    },
    [GAME_EVENTBRITE_FORMAT]: {
        link: game_link,
        full: '',
    },
    [RACE_EVENTBRITE_FORMAT]: {
        link: race_link,
        full: '',
    },
    [TOUR_EVENTBRITE_FORMAT]: {
        link: tour_link,
        full: '',
    },
    [ATTRACTION_EVENTBRITE_FORMAT]: {
        link: attraction_link,
        full: '',
    },
    [RETREAT_EVENTBRITE_FORMAT]: {
        link: retreat_link,
        full: '',
    },
    [APPEARANCE_EVENTBRITE_FORMAT]: {
        link: appearance_link,
        full: '',
    },
};

export const EVENTBRITE_FORMAT_TO_REFINEMENT = {
    [CONFERENCE_EVENTBRITE_FORMAT]: 'conferences',
    [SEMINAR_EVENTBRITE_FORMAT]: 'seminars',
    [EXPO_EVENTBRITE_FORMAT]: 'expos',
    [CONVENTION_EVENTBRITE_FORMAT]: 'conventions',
    [FESTIVAL_EVENTBRITE_FORMAT]: 'festivals',
    [PERFORMANCE_EVENTBRITE_FORMAT]: 'performances',
    [SCREENING_EVENTBRITE_FORMAT]: 'screenings',
    [GALA_EVENTBRITE_FORMAT]: 'galas',
    [CLASS_EVENTBRITE_FORMAT]: 'classes',
    [NETWORKING_EVENTBRITE_FORMAT]: 'networking',
    [PARTY_EVENTBRITE_FORMAT]: 'parties',
    [RALLY_EVENTBRITE_FORMAT]: 'rallies',
    [TOURNAMENT_EVENTBRITE_FORMAT]: 'tournaments',
    [GAME_EVENTBRITE_FORMAT]: 'games',
    [RACE_EVENTBRITE_FORMAT]: 'races',
    [TOUR_EVENTBRITE_FORMAT]: 'tours',
    [ATTRACTION_EVENTBRITE_FORMAT]: 'attractions',
    [RETREAT_EVENTBRITE_FORMAT]: 'retreats',
    [APPEARANCE_EVENTBRITE_FORMAT]: 'appearances',
};
